import HundredBricksAPIError from '../HundredBricksAPIError';
class LogoutError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('LogoutError', ...args);
    }
}
export default LogoutError;
